@if (formGroup.get(property.Key) && !isActionButton(property)) {
  <div [formGroup]="formGroup" [matTooltip]="toolTipTextId | translate" class="container">
    <mat-checkbox [id]="property.Key" [formControlName]="property.Key">{{ property.TextId | translate }}</mat-checkbox>
  </div>
}

<!-- If the boolean is configured to be a button, show it as one and bind the click event to set the property value to true -->
@if (isActionButton(property)) {
  <button
    mat-button
    mat-stroked-button
    color="primary"
    type="button"
    (click)="propertyChange.emit({ Key: property.Key, Value: true, MeasurementUnitKey: '' })"
  >
    {{ property.TextId | translate }}
  </button>
}
